import { render, staticRenderFns } from "./list-dependence-standar.vue?vue&type=template&id=6ac49805"
import script from "./list-dependence-standar.vue?vue&type=script&lang=js"
export * from "./list-dependence-standar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports